module.exports = __webpack_public_path__ + "static/media/HCMM934.f65a3ec3.jpg";